import { Show, createFeature } from '@edreamsodigeo/frontend-core';
import DiscountPill from '@components/Results/Components/DiscountPill';
import { PRIME_DAYS } from 'clientState/ab/aliases';
import React, { FC } from 'react';

type PrimeDayDiscountPillProps = {
  price: number;
  discountedPrice: number;
  isPrimeDayFare: boolean;
};

const PrimeDayDiscountPill: FC<PrimeDayDiscountPillProps> = ({
  price,
  discountedPrice,
  isPrimeDayFare,
}) => (
  <Show when={isPrimeDayFare}>
    <DiscountPill price={price} discountedPrice={discountedPrice} />
  </Show>
);

const DiscountPillVersioned = createFeature({
  name: PRIME_DAYS,
  variations: [null, PrimeDayDiscountPill, PrimeDayDiscountPill],
  version: 1,
});

export default DiscountPillVersioned;
